import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static targets = ["error", "dialog", "confirmation"];
    declare readonly dialogTarget: HTMLDialogElement;
    declare readonly confirmationTarget: HTMLElement;
    static values = { error: String, busy: String };
    declare readonly errorTarget: HTMLElement;
    declare readonly errorValue: string;
    declare readonly busyValue: string;

    open(): void {
        if (!this.confirmationTarget.hidden) return;
        this.clear();
        queueMicrotask(() => this.dialogTarget.showModal());
    }

    cancel(): void {
        this.dialogTarget.close();
    }

    clear(): void {
        this.errorTarget.textContent = "";
        this.errorTarget.classList.add("hidden");
    }

    complete(event: CustomEvent<{ successful: boolean; xhr?: XMLHttpRequest }>): void {
        if (event.detail.successful && event.detail.xhr?.status === 204) {
            this.dialogTarget.close();
            this.element.querySelector<HTMLElement>(".dropdown-menu")?.classList.add("hidden");
            this.confirmationTarget.hidden = false;
            // Keep the acknowledgement through a stale same-ticket render. A closed
            // ticket removes this whole component; navigation resets preservation.
            this.element.dataset.streamPreserveSelf = "true";
            return;
        }
        this.errorTarget.textContent = event.detail.xhr?.status === 409 ? this.busyValue : this.errorValue;
        this.errorTarget.classList.remove("hidden");
    }
}
